export default "__VITE_ASSET__BEdQPD0f__"